import React, { Component } from 'react';
import "./index.scss";
import { requests, getToken, loadZhuKeToken, getLoginShopInfo, isNotNull,messageShow, millisecondToDate,getPlatformName } from '../../utils/http';
import Loading from './../showLoading/showLoading';
import { Input, Select, Button, Pagination, Checkbox, Radio, Message, Tooltip, Tag, Dialog } from 'element-react';


class SelectCategoryModule extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ShopId: props.targetShopId,
      platformType: props.targetPlatformType,
      ParentId: "0",//目录父级ID
      isMoreSelectShow: props.showSelectCategoryModule,//类目选择框隐藏
      showSelectsList: [],
      CateList: [],                //选中的目录结构
      inputSearchValue: "",            //搜索value
      returnCount: 50,    //搜索类目最多条数
      noSearchCtegory: false,
      searchCtegoryList: []
    };
  }
  componentDidMount() { //组件挂载到DOM渲染后被执行，只会执行一次。
    this.loadCategoryList(this.state.ShopId, this.state.ParentId);
    // document.onclick = this.listentClickDocument;
  }
  componentWillReceiveProps(props) {  //监听父元素 传过来值的变化 触发的函数
    this.setState({
      isMoreSelectShow: props.showSelectCategoryModule,//类目选择框隐藏
      noSearchCtegory:false
    })
  }

  loadCategoryList(ShopId, ParentId) {
    var that = this;
    that.setState({ isLoading: true, loadingTitle: '加载类目中...' });
    requests({
      url: "/ListingConfig/GetListingCategory",
      data: { ShopId: ShopId, ParentId: ParentId },
      success: function (res) {
        that.setState({ isLoading: false, loadingTitle: '加载店铺信息...' });
        if (res.RequestError == true)//请求失效了。isLoading关闭看需求写
          return;
        if (res.Success) {
          let showSelectsList = that.state.showSelectsList;
          let level = showSelectsList.length ? showSelectsList.length + 1 : "1";
          let resultData = res.Data;
          for (let i = 0; i < resultData.length; i++) {  //为每项添加两个字段
            resultData[i].check = false;   //标记选中或不选中
            resultData[i].level = level;   //level为内目层级
          }
          if (resultData.length > 0) {
            showSelectsList.push(resultData)
            that.setState({
              showSelectsList: showSelectsList,
            })
          } else
              messageShow("没有获取到类目信息","success");

        } else {
          messageShow("获取类目错误：" + res.Message,"error");
        }
      },
    });
  }

  checkSelectCategoryClick = (event,IsParent)=>
  {
    let id = event.currentTarget.getAttribute('data-id');
    let level = parseInt(event.currentTarget.getAttribute('data-level'));

    this.checkSelectCategory(id,level,IsParent);
  }

  checkSelectCategory = (id, level, IsParent) => {  //选择目录时触发函数
    let ShopId = this.state.ShopId;
    let showSelectsList = this.state.showSelectsList;
    for (let i = 0; i < showSelectsList[level - 1].length; i++) {
      if (showSelectsList[level - 1][i].Id == id) {
        showSelectsList[level - 1][i].check = true;
      } else {
        showSelectsList[level - 1][i].check = false;
      }
    }
    showSelectsList = showSelectsList.slice(0, level);//删除后面有选中的数组
    this.setState({
      showSelectsList: showSelectsList
    }, () => {
      if (IsParent) {
        this.setState({
          selectCategoryId: ""
        })
        this.loadCategoryList(ShopId, id, IsParent);
      } else {  //没有下级了
        let selectTitle = "";       //选择最后一项后，内目赋值给标题
        let selectCategoryAllIds = "";//保存选中的ID
        let CateList = [];            //保存选中的目录
        for (let i = 0; i < showSelectsList.length; i++) {
          for (let j = 0; j < showSelectsList[i].length; j++) {
            if (showSelectsList[i][j].check) {
              let obj = {};
              selectTitle += showSelectsList[i][j].Name + "—";
              obj.Id = showSelectsList[i][j].Id;
              obj.Name = showSelectsList[i][j].Name;
              CateList.push(obj);
            }
          }
        }
        selectTitle = selectTitle.substr(0, selectTitle.length - 1)
        this.setState({
          selectCategoryId: id,
          selectTitle: selectTitle,
          CateList: CateList,
          isMoreSelectShow: false,
        }, () => {
          this.props.selectCategory(CateList, selectTitle)
        })
      }
    })
  }


  onSearchCategory = (event) => {
    let value = event.trim();
    this.setState({
      inputSearchValue: value
    })
  }

  //搜索关键词找类目
  searchCategoryList = () => {
    let that = this;
    let targetShopId = this.state.ShopId;
    let inputSearchValue = this.state.inputSearchValue;
    var platformName = this.state.platformType;
    var returnCount = this.state.returnCount;
    if (inputSearchValue.trim() == "") {
      messageShow("请输入类目关键词","warning");
      return;
    }
    this.setState({ isLoading: true })
    requests({
      url: "/listingconfig/SearchCategories",
      data: { ShopId: targetShopId, CateName: inputSearchValue, ReturnCount: returnCount, ShopPt: platformName },
      success: (res) => {
        that.setState({ isLoading: false });
        if (res.Success) {
          let relustData = res.Data;
          let newRelustData = GetData(relustData, returnCount);//格式化搜索类目数据
          let noSearchCtegory = newRelustData.length > 0 ? true : false;
          if(!noSearchCtegory){
            messageShow("搜索不到类目","warning");
          }

          that.setState({
            searchCtegoryList: newRelustData,
            noSearchCtegory: noSearchCtegory
          })
          function GetData($array, returnCount) {
            var datas = [];
            for (var i = 0; i < $array.length; i++) {
              var arrays = [];
              GetTextValu($array[i], arrays);
              var obj = {};
              obj.arrays = arrays;
              obj.names = "";
              obj.lastName = "";
              obj.lastId = 0;
              for (var j = 0; j < arrays.length; j++) {
                if (j == 0) {
                  obj.names += arrays[j].Name;
                } else {
                  obj.names += " - " + arrays[j].Name;
                }
              }
              datas.push(obj);
              if (datas.length >= returnCount)
                break;
            }
            if (datas.length > returnCount)
              datas.splice(0, returnCount);
            return datas;
          }

          function GetTextValu(obj, keyVal) {
            if (obj == null)
              return;
            keyVal.push({ Id: obj.Id, Name: obj.Name });
            if (obj.Child == null || obj.Child.length == 0)
              return;
            for (var i = 0; i < obj.Child.length; i++)
              GetTextValu(obj.Child[i], keyVal);
          }

        }

      }
    });
  }

  handleKeyDownSearchCategory(e) {
    if (e.keyCode == 13) {
      this.searchCategoryList();
    }
  }

  checkSearchCategory(CateList,selectTitle){
      this.props.selectCategory(CateList, selectTitle)
  }

  render() {
    let { noSearchCtegory, searchCtegoryList } = this.state;
    return (
      this.state.isMoreSelectShow ?
        <div className="moreSelect-main newCategoryWrap">
          <div className="categoryWrap">
            <div className="searchCategoryWrap">
              <Input
                className="searchCategoryInput"
                onChange={(v) => this.onSearchCategory(v)}
                //innerAfter={<Icon size="small" type="search" className="searchIcon" onClick={() => this.searchCategoryList()} />}
                placeholder="请输入类目关键词"
                onKeyDown={e => this.handleKeyDownSearchCategory(e)}
                icon="search"
                onIconClick={() => this.searchCategoryList()}

              />
            </div>
            {
              noSearchCtegory ?
                <ul className="showSearchCtegory">
                  {
                    searchCtegoryList.map((item, i) =>
                      <li className="showSearchCtegory-item" title={item.names} onClick={() => this.checkSearchCategory(item.arrays,item.names)}><s>{i + 1}</s><span>{item.names}</span></li>
                    )
                  }

                </ul> : null
            }
          </div>

          {
            !noSearchCtegory?
            <div className="moreSelect-main selectCategoryWrap">
            {this.state.showSelectsList.map((item, index) =>
              <ul className='scroll-x'>
                {
                  item.map((item02, index) =>
                    <li className={item02.check ? "active" : ""} data-id={item02.Id} data-level={item02.level} data-value={item02.Name} onClick={(e, IsParent) => this.checkSelectCategoryClick(e, item02.IsParent)}>
                      <span>{item02.Name}</span>
                      {item02.IsParent ?
                        <i className="iconfont icon-down"></i> : null
                      }
                    </li>
                  )
                }
              </ul>
            )}
          </div>:null
          }



          <Loading isLoading={this.state.isLoading} hasBorder={true} isShade={false} isStopOperate={true} title={this.state.loadingTitle} />
        </div> : null
    );
  }



};

export default SelectCategoryModule;



// WEBPACK FOOTER //
// ./src/components/selectCategoryModule/index.jsx